import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangleIcon, HomeIcon, ArrowLeftIcon } from 'lucide-react';
export function NotFoundPage() {
  return <div className="flex flex-col w-full min-h-screen bg-[#050505] text-white" data-id="element-9477">
      <header className="bg-white/5 backdrop-blur-md border-b border-white/10" data-id="element-9478">
        <div className="max-w-4xl mx-auto px-5 py-4 flex items-center gap-3" data-id="element-9479">
          <img src="https://cdn.magicpatterns.com/uploads/65popPutPXjwqKGt3qtuH1/flag.jpg" alt="ToxicDetector logo" className="w-7 h-7 object-contain" data-id="element-9480" />
          <span className="text-lg font-black text-white uppercase tracking-tight" data-id="element-9481">
            ToxicDetector
          </span>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-5" data-id="element-9482">
        <div className="text-center max-w-md" data-id="element-9483">
          <div className="w-20 h-20 mx-auto mb-8 rounded-2xl bg-red-500/10 border border-red-500/20 flex items-center justify-center" data-id="element-9484">
            <AlertTriangleIcon className="w-10 h-10 text-red-500" data-id="element-9485" />
          </div>

          <h1 className="text-6xl font-black text-white tracking-tighter mb-3" data-id="element-9486">
            404
          </h1>
          <h2 className="text-xl font-bold text-white/80 mb-3" data-id="element-9487">
            Page Not Found
          </h2>
          <p className="text-white/50 text-sm font-mono mb-10 leading-relaxed" data-id="element-9488">
            The page you're looking for doesn't exist or has been moved.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3" data-id="element-9489">
            <Link to="/" className="inline-flex items-center gap-2 bg-[#FF0000] text-white px-6 py-3 font-black text-sm uppercase tracking-widest hover:bg-red-600 transition-all shadow-[0_0_15px_rgba(255,0,0,0.3)]" data-id="element-9490">
              <HomeIcon size={16} data-id="element-9491" />
              Go Home
            </Link>
            <button onClick={() => window.history.back()} className="inline-flex items-center gap-2 bg-white/10 text-white px-6 py-3 font-bold text-sm uppercase tracking-widest hover:bg-white/20 transition-all border border-white/10" data-id="element-9492">
              <ArrowLeftIcon size={16} data-id="element-9493" />
              Go Back
            </button>
          </div>
        </div>
      </main>
    </div>;
}